import * as React from 'react'
import type { SVGProps } from 'react'
import type { Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgGridView = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 16 16'
    ref={ref}
    aria-labelledby={titleId}
    // {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}

    <path d="M6 2H2.66667C2.29848 2 2 2.29848 2 2.66667V6C2 6.36819 2.29848 6.66667 2.66667 6.66667H6C6.36819 6.66667 6.66667 6.36819 6.66667 6V2.66667C6.66667 2.29848 6.36819 2 6 2Z" stroke={props.color} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M13.3333 2H9.99998C9.63179 2 9.33331 2.29848 9.33331 2.66667V6C9.33331 6.36819 9.63179 6.66667 9.99998 6.66667H13.3333C13.7015 6.66667 14 6.36819 14 6V2.66667C14 2.29848 13.7015 2 13.3333 2Z" stroke={props.color} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M13.3333 9.3335H9.99998C9.63179 9.3335 9.33331 9.63197 9.33331 10.0002V13.3335C9.33331 13.7017 9.63179 14.0002 9.99998 14.0002H13.3333C13.7015 14.0002 14 13.7017 14 13.3335V10.0002C14 9.63197 13.7015 9.3335 13.3333 9.3335Z" stroke={props.color} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M6 9.3335H2.66667C2.29848 9.3335 2 9.63197 2 10.0002V13.3335C2 13.7017 2.29848 14.0002 2.66667 14.0002H6C6.36819 14.0002 6.66667 13.7017 6.66667 13.3335V10.0002C6.66667 9.63197 6.36819 9.3335 6 9.3335Z" stroke={props.color} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
   
  </svg>
)
const ForwardRef = forwardRef(SvgGridView)
export default ForwardRef
